// FILTERS
import {Sorter} from './sorters';
import {GetAssetBiodiversityParams} from '../../api/assets';
import {OptionLabelValue} from '../OptionLabelValue';

const BiodiversityNumberFilters = [
  'distance',
  'coverage',
] as const;
export type BiodiversityNumberFilters = (typeof BiodiversityNumberFilters)[number];
const isBiodiversityNumberFilters = (x: any): x is BiodiversityNumberFilters => BiodiversityNumberFilters.includes(x);

const biodiversityTableOptionLabelValueFilters = [
  'name',
  'data_source',
  'designation',
  'designation_type',
  'pa_id',
] as const;
export type BiodiversityOptionLabelValueFilters = (typeof biodiversityTableOptionLabelValueFilters)[number];
export const isBiodiversityOptionLabelValueFilters = (x: any): x is BiodiversityOptionLabelValueFilters => biodiversityTableOptionLabelValueFilters.includes(x);

export type BiodiversityFiltersFE = Partial<
  Record<BiodiversityNumberFilters, number> &
  Record<BiodiversityOptionLabelValueFilters, OptionLabelValue[]>
>

export type BiodiversityFilters = (
  typeof BiodiversityNumberFilters)[number] |
  typeof biodiversityTableOptionLabelValueFilters[number]
  ;
export const isBiodiversityFilters = (x: any): x is BiodiversityFilters => [
  ...BiodiversityNumberFilters,
  ...biodiversityTableOptionLabelValueFilters,
].includes(x);

export function fromFeToBeBiodiversityTableFilters(tableFilters: BiodiversityFiltersFE) {
  let parsedFilters: Partial<GetAssetBiodiversityParams> = {};
  for (const [key, value] of Object.entries(tableFilters)) {
    if (
      isBiodiversityNumberFilters(key)) {
      if (key === 'coverage') {
        const parsedValue = ( (value as number) / 100).toString();
        parsedFilters = {...parsedFilters, [key as keyof GetAssetBiodiversityParams]: parsedValue};
      } else {
        parsedFilters = {...parsedFilters, [key as keyof GetAssetBiodiversityParams]: value};
      }
    } else if (isBiodiversityOptionLabelValueFilters(key)) {
      const parsedValue = (value as OptionLabelValue[]).map(el => el.value)
        .join(',');
      parsedFilters = {...parsedFilters, [key]: parsedValue};
    }
  }
  return parsedFilters;
}

// COLUMNS
export const biodiversityColumns = [
  'distance',
  'name',
  'designation',
  'designation_eng',
  'designation_type',
  'pa_id',
  'data_source',
  'area_km2',
  'coverage'
] as const;

export type BiodiversityColumns = (typeof biodiversityColumns)[number]
export const isBiodiversityColumns = (x: any): x is BiodiversityColumns => biodiversityColumns.includes(x);

// SORTERS
export type BiodiversitySortersFE = Partial<{
  [K in BiodiversityColumns]: Sorter
}>
